import {SolutionStep} from './SolutionStep';

export class ActionConfirm {
  static BACKOFFICE_TYPE = 0;
  static DEALER_TYPE = 1;
  public message: string;
  public type: number;
  public primaryOption: string;
  public secondaryOption: string;
  public primaryStep: number | SolutionStep;
  public secondaryStep: number | SolutionStep;
}
